import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import { ColorButton } from "../../material-components/Misc/Button";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import h from "../../../helpers";

const UploadAdminFieldsModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();

    const [uploadFile, setUploadFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [dataType, setDataType] = useState("");
    const [owner, setOwner] = useState("Current");
    const [uploadBtn, setUploadBtn] = useState(null);

    const roles = useSelector(state => state.session.roles || []);

    const hide = () => {
        setUploadFile(null);
        setFileName("");
        setDataType("");
        setOwner("Current");
        setUploadBtn(null);
        dispatch(hideModal("UPLOAD_FIELDS"));
    };

    const onUploadClick = () => {
        h.throwGTMTrigger("button_click", "button", "Edit Field", "ActionsMenu", "Upload File");
        const isExperianAsset = owner !== "Current";
        modalProps.uploadDataFile(dataType, uploadFile, isExperianAsset);
        hide();
    };

    const selectedFileChanged = () => {
        const file = uploadBtn.files[0];
        if (file) {
            setFileName(file.name);
            setUploadFile(file);
        }
        uploadBtn.value = null;
    };

    return (
        <MaterialModal
            id="upload-admin-modal"
            isOpen={isOpen}
            onClose={hide}
            title={"Upload"}
            showPrimaryButton={true}
            primaryButtonText="Upload"
            isPrimaryButtonDisabled={!fileName || fileName == "" || modalProps.disabled || dataType == ""}
            onPrimaryButtonRequest={onUploadClick}
            cancelButtonText="Close"
        >
            <div>
                Select which type of data you are uploading.
                <FormControl>
                    <RadioGroup row name="type" value={dataType} onChange={e => setDataType(e.target.value)}>
                        <div style={{ marginLeft: "25px", marginTop: "10px", marginBottom: "10px" }}>
                            <FormControlLabel value="fields" control={<Radio color="primary" />} label="Fields" />
                            <FormControlLabel value="metadata" control={<Radio color="primary" />} label="Metadata" />
                        </div>
                    </RadioGroup>
                </FormControl>
            </div>
            {(roles.includes("Experian Admin") || roles.includes("Super Admin")) && (
                <div>
                    Select who owns the data you are uploading.
                    <FormControl>
                        <RadioGroup row name="owner" value={owner} onChange={e => setOwner(e.target.value)}>
                            <div style={{ marginLeft: "25px", marginTop: "10px", marginBottom: "10px" }}>
                                <FormControlLabel
                                    value="Current"
                                    control={<Radio color="primary" />}
                                    label="Current Company"
                                />
                                <FormControlLabel
                                    value="Experian"
                                    control={<Radio color="primary" />}
                                    label="Experian Asset"
                                />
                            </div>
                        </RadioGroup>
                    </FormControl>
                </div>
            )}
            <p>Click the Browse button and choose the file you wish to upload.</p>
            <div className="input-group" style={{ marginLeft: "auto" }}>
                <label className="input-group-btn">
                    <ColorButton
                        backgroundcolor="#0075bc"
                        component="span"
                        variant="contained"
                        style={{ marginBottom: "10px", fontSize: 12 }}
                    >
                        Browse
                        <input
                            id="contained-button-file"
                            ref={c => setUploadBtn(c)}
                            type="file"
                            name="File"
                            accept=".xlsx"
                            style={{ display: "none" }}
                            onChange={selectedFileChanged}
                        />
                    </ColorButton>
                </label>
                <TextField
                    id="uploadFile"
                    type="text"
                    style={{ padding: "0px 10px" }}
                    InputProps={{
                        readOnly: true,
                    }}
                    value={fileName}
                />
            </div>
        </MaterialModal>
    );
};

UploadAdminFieldsModal.propTypes = {
    isOpen: PropTypes.bool,
    isLayoutTree: PropTypes.bool,
    hideModal: PropTypes.func,
    modalProps: PropTypes.any,
    notifyBlack: PropTypes.func,
    notifyGreen: PropTypes.func,
    requestLayoutFieldTree: PropTypes.func,
    requestEditFieldTree: PropTypes.func,
    roles: PropTypes.array,
};

export default withModal(UploadAdminFieldsModal, "UPLOAD_FIELDS");
